import './App.css';
import RouterFunction from './shared/routes';
import React, { useEffect } from 'react';
import { getConfig } from './shared/services/config.service';
import { connect, useDispatch } from 'react-redux';
import SubDomainError from './tenant-app/pages/main/subdomainError';
import AdminRoutes from './shared/routes/admin';

function App(props) {
  const dispatch = useDispatch();
  const tenantInfo = props.tenantInfo;
  const host = window.location.host.split('.')[0];

  useEffect(() => {
    dispatch(getConfig());
  }, [dispatch]);

  if (host === 'admin') {
    return (
      <div className=" overflow-x-hidden">
        <AdminRoutes />
      </div>
    );
  }
  if (host !== 'admin' && (tenantInfo === undefined || tenantInfo === null)) {
    return <SubDomainError />;
  }
  // if (host !== 'admin' && Object.keys(tenantInfo).length === 0) {
  //   return <SubDomainError />;
  // }
  // if (host !== 'admin' && typeof tenantInfo === 'undefined') {
  //   return <SubDomainError />;
  // }
  else {
    return (
      <div className=" overflow-x-hidden">
        <RouterFunction />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tenantInfo: state.tenants.tenantConfig,
});
export default connect(mapStateToProps, { getConfig })(App);
